import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { SPACING_TOKEN_MAP } from '../constants';
import { type SpacingToken } from '../types';

type SpacerProps = StructuredContentDocument<{
  spacing: SpacingToken;
}>;

export const Spacer = ({ props }: SpacerProps) => {
  const { spacing } = props;

  return (
    <div
      className={css({ marginBottom: 'var(--spacer-margin-bottom)' })}
      style={{ '--spacer-margin-bottom': SPACING_TOKEN_MAP[spacing] } as React.CSSProperties}
    />
  );
};
